import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import styled from '@grebban/style-system-react';
import PropTypes from 'prop-types';

/**
 * This is a base link component supporting internal linking with the help react router dom and external linking with a regular <a> element.
 * It handles all the parameters and stylings of an <a> element except "href" that has been replaced by to.
 *
 * @param {bool} volatile - If true, the component is renderd as a link and the to-prop is false the component will only render its children.
 * @param {string | object} to - Can be the href can be an object holding pathname amongst other things (see https://v5.reactrouter.com/web/api/Link).
 */

const StyledLink = styled('a')``;
const StyledReactRouterLink = styled(ReactRouterLink)``;

//@TODO Make sure to implement the fix for if the application path is sent in to, remove it.
const Link = React.forwardRef(({ children, to, target, volatile, rel, applicationPath, ...rest }, ref) => {
    // const applicationPath = useSelector(({ application }) => application?.site?.path || '');

    // If there is no link and the Link component is volatile, we just render the children.
    if (!to && (volatile || volatile === undefined)) {
        return <>{children}</>;
    }

    // If link is an object
    if (typeof to === 'object') {
        return (
            <StyledReactRouterLink ref={ref} to={{ ...to, pathname: `${applicationPath}${to?.pathname || ''}` }} {...rest}>
                {children}
            </StyledReactRouterLink>
        );
    }

    // If the link is just a string and it is an external url.
    if (typeof to === 'string' && to?.charAt(0) !== '/' && to?.charAt(0) !== '#') {
        return (
            <StyledLink ref={ref} href={`${applicationPath}${to}`} target={target || '_blank'} rel={rel || 'noopener noreferrer'} {...rest}>
                {children}
            </StyledLink>
        );
    }

    return (
        <StyledReactRouterLink ref={ref} to={`${applicationPath}${to || ''}`} {...rest}>
            {children}
        </StyledReactRouterLink>
    );
});

Link.propTypes = {
    applicationPath: PropTypes.string,
    children: PropTypes.node.isRequired,
    rel: PropTypes.string,
    target: PropTypes.string,
    to: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            pathname: PropTypes.string,
            search: PropTypes.string,
            hash: PropTypes.string,
            state: PropTypes.object,
        }),
    ]),
    volatile: PropTypes.bool,
};
Link.defaultProps = {
    applicationPath: '',
    rel: '',
    target: '',
    to: '',
    volatile: true,
};

export default Link;
